// ------------------------***----------------------------
//
// USE THE <BUTTON /> COMPONENT INSTEAD!!
//
// THIS COMPONENT IS DEPRECATED, IT IS ONLY RETAINED UNTIL
// ALL INSTANCES ARE MIGRATED TO <BUTTON />
//
// ------------------------***----------------------------

import React from 'react';

import { Button, CircularProgress, Typography } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import { makeStyles, Theme } from '@material-ui/core/styles';

export interface Props extends ButtonProps {
  label: string;
  loading?: boolean;
  testId?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  buttonWithLoader: {
    borderRadius: 0,
    bottom: 0,
    cursor: 'pointer',
    left: 0,
    padding: theme.spacing(2),
    position: 'fixed',
    right: 0,
    textAlign: 'center',
    verticalAlign: 'baseline',
    zIndex: theme.zIndex.appBar,

    '& span': {
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    '&.MuiButton-contained': {
      '& .MuiTypography-button': {
        marginLeft: theme.spacing(1),
      },
    },
    // [theme.breakpoints.up('s')]: {
    // }
  },

  loader: {
    left: '50%',
    marginLeft: -12,
    marginTop: -12,
    position: 'absolute',
    top: '50%',

    // [theme.breakpoints.down('xs')]: {}
  },
}));

export const ButtonWithLoader = (props: Props): JSX.Element => {
  const classes = useStyles();
  const {
    disabled,
    label,
    loading,
    size = 'large',
    testId = '',
    ...rest
  } = props;

  return (
    <Button
      {...rest}
      className={classes.buttonWithLoader}
      data-fd={testId}
      disabled={disabled || loading}
      size={size}
      fullWidth
      type="submit"
    >
      {loading && (
        <CircularProgress
          aria-hidden
          className={classes.loader}
          size={size === 'large' ? 20 : 16}
        />
      )}

      <Typography component="span" variant="button">
        {label}
      </Typography>
    </Button>
  );
};
